import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import { Typography, TableCell, IconButton, TableRow, Grid } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info'
import { genfunction } from 'helpers'

import NumberSpinner from 'components/InputControls/NumberSpinner';
const { DisplayGATicketExpiryValidity } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    header: {
        textAlign: "center",
        padding: 10,

        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    items: {
        padding: 20
    }
}));

const GAGroupItem = props => {

    const classes = useStyles();

    const gatickets = useSelector(state => state.reducerShopCart.GATickets);

    const getShopcartTicketQty = (ProductID) => {
        let ticket = gatickets.find(t => t.ProductID === ProductID);
        if (ticket)
            return ticket.Quantity
        else
            return 0;
    }

    return (
        <div>
            <Typography variant="h5" color="primary" className={classes.header} >{props.GroupHeader}</Typography>
            <div className={classes.items}>
                {props.GroupItems.map(ticket => (
                    <Grid container spacing={5} >
                        <Grid container item xs={8}>
                            <Grid item sm={1} xs={2}>
                                <IconButton
                                    edge="end"
                                    size="small"
                                    onClick={() => { props.InfoClickHandler(ticket.ProductID) }}
                                >
                                    <InfoIcon
                                        color={"primary"}
                                    />
                                </IconButton>
                            </Grid>
                            <Grid item sm={11} xs={10}>
                                <Typography variant="subtitle1" color="textPrimary" >{ticket.ProductName} {genfunction.ccyFormat(ticket.Price)}</Typography>
                                {DisplayGATicketExpiryValidity ?
                                    <Typography variant="caption" color="textPrimary" >{'Valid until ' + genfunction.GetEventDate(ticket.GATicketExpiryDate)}</Typography>
                                    : ""}
                                {ticket.OriginalPrice && (ticket.OriginalPrice > ticket.Price) ?
                                    <div>
                                        <Typography variant="caption" color="textPrimary" >{'You Save ' + genfunction.ccyFormat((ticket.OriginalPrice - ticket.Price))}</Typography>
                                    </div>
                                    : ""}
                            </Grid>
                        </Grid>
                        <Grid item xs={4} align="right">
                            <NumberSpinner refrence={{ eventId: ticket.ProductID, tourProductID: ticket.ProductID }}
                                value={parseInt(ticket.Quantity)}
                                minValue={0} maxValue={ticket.MaxQuantity - getShopcartTicketQty(ticket.ProductID)} steps={1}
                                changeHandler={(refrence, value) => { props.ChangeQuantityHandler(refrence, value) }}></NumberSpinner>
                        </Grid>
                    </Grid>
                ))}
            </div>
        </div>
    );
};

export default GAGroupItem;
